/* =========================================================
   Kipor Zeitstrahl (<kipor-timeline>)
   - Scroll-Fortschritt: die dunkle Linie waechst mit, bis zu
     der Hoehe, die gerade im unteren Teil des Fensters liegt.
   - Optional (data-animate): Eintraege blenden beim Sichtbar-
     werden seitlich ein. Ohne JS / bei reduzierter Bewegung
     bleibt alles sofort sichtbar.
   ========================================================= */
(function () {
  'use strict';
  if (window.customElements.get('kipor-timeline')) return;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var VIEWPORT_ANCHOR = 0.85; // Anteil der Fensterhoehe, bis zu dem die Linie gefuellt ist

  class KiporTimeline extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this._onScroll = this.requestUpdate.bind(this);
      window.addEventListener('scroll', this._onScroll, { passive: true });
      window.addEventListener('resize', this._onScroll, { passive: true });
      this.update();

      if (this.hasAttribute('data-animate') && !reduceMotion.matches && 'IntersectionObserver' in window) {
        var items = this.querySelectorAll('.kipor-timeline__item');
        this._io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              this._io.unobserve(entry.target);
            }
          }, this);
        }.bind(this), { rootMargin: '0px 0px -10% 0px', threshold: 0.1 });

        // Eintraege, die schon im Bild sind, nicht erst ausblenden.
        var vh = window.innerHeight;
        items.forEach(function (item) {
          var r = item.getBoundingClientRect();
          if (r.top < vh * 0.9 && r.bottom > 0) item.classList.add('is-visible');
          else this._io.observe(item);
        }, this);
        this.classList.add('is-animated');
      }

      this._onBlockSelect = function (e) {
        var item = e.target.closest && e.target.closest('.kipor-timeline__item');
        if (item) item.classList.add('is-visible');
      };
      this.addEventListener('shopify:block:select', this._onBlockSelect);
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this._onScroll);
      window.removeEventListener('resize', this._onScroll);
      if (this._io) this._io.disconnect();
    }

    requestUpdate() {
      if (this._raf) return;
      this._raf = requestAnimationFrame(function () {
        this._raf = null;
        this.update();
      }.bind(this));
    }

    update() {
      var r = this.getBoundingClientRect();
      if (!r.height) return;
      var p = (window.innerHeight * VIEWPORT_ANCHOR - r.top) / r.height;
      p = Math.max(0, Math.min(1, p));
      this.style.setProperty('--kp-tl-progress', p.toFixed(4));
    }
  }

  window.customElements.define('kipor-timeline', KiporTimeline);
})();
